// Check if two values are not equal
export default function (first, second, options) {
  if (first !== undefined && second !== undefined && first != second) {
    return options.fn(this);
  }
  return options.inverse(this);
}
